export enum NavTabDef {
  PRODUCTS = 'Products',
  BLOG = 'Blog',
  MAP = 'Map',
  ABOUT = 'About',
  SIZE_GUIDE = 'Size Guide',
  SHIPPING = 'Shipping',
  RETURNS_EXCHANGES = 'Returns & Exchanges',
  ALTERATIONS = 'Alterations',
  CONTACT = 'Contact',
}
